import Color from "color";
export const calcColorGradient = (color) => {
  const pickedColor = Color(color);
  // Gradient options
  const gradientOptions = [25, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950, 975];
  const lum = pickedColor.hsl().color[2] * 10;
  const closest = [...gradientOptions].sort((a, b) => Math.abs(lum - a) - Math.abs(lum - b))[0];

  // Rendering the gradient squares
  const gradientRendered = gradientOptions.map((gradientOption) => {
    // If the selected color is in the same gradient option we don't want to manipulate the color but we want to notify the user
    const colorIsGradientOption = closest === gradientOption;
    const newColor = colorIsGradientOption
      ? pickedColor
      : pickedColor.lightness(gradientOption / 10);

    return {
      gradientHex: Color(newColor).hex(),
      isGradientOption: colorIsGradientOption,
      gradientOption: gradientOption,
    };
  });

  return gradientRendered;
};
